import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=2c6e4a2e&scoped=true"
import script from "./PhotoEditor.vue?vue&type=script&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&lang=js"
import style0 from "./PhotoEditor.vue?vue&type=style&index=0&id=2c6e4a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e4a2e",
  null
  
)

export default component.exports